import { render, staticRenderFns } from "./ERegistrationOwnerRegisterView.vue?vue&type=template&id=2e80ecd6&scoped=true&"
import script from "./ERegistrationOwnerRegisterView.vue?vue&type=script&lang=js&"
export * from "./ERegistrationOwnerRegisterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e80ecd6",
  null
  
)

export default component.exports